export const FETCH_REPORT_KB_ARTICLES_REQUEST =
  'reports/kb/FETCH_REPORT_KB_ARTICLES_REQUEST'
export const FETCH_REPORT_KB_ARTICLES_RESPONSE =
  'reports/kb/FETCH_REPORT_KB_ARTICLES_RESPONSE'
export const FETCH_REPORT_KB_ARTICLES_ERROR =
  'reports/kb/FETCH_REPORT_KB_ARTICLES_ERROR'
